import { GridColDef } from "@mui/x-data-grid-pro";
import { useHostPlayerTrips } from "services/api/SWRService";
import { IHostTrip } from "services/models/Host";
import { PlayerNameCell } from "./PlayerNameCell";
import { numberCol, tierCol } from "utils/datagrid-utils";
import { GridPaginationProps } from "./helpers";
import { SWRDataGrid } from "./SWRDataGrid";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from ".";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";

export type HostPlayerTripType = "increasing" | "decreasing";
type Prop = {
  type: HostPlayerTripType;
} & GridPaginationProps;

export interface HostTrip {
  clubNumber: string;
  fullName: string;
  firstName: string;
  lastName: string;
  hostName: string;
  averageVisits6Months: string;
  visitsLast30Days: string;
  currentTierColor: string;
}

const columns: GridColDef<IHostTrip>[] = [
  {
    field: "currentTier",
    headerName: "Tier",
    ...tierCol,
  },
  {
    field: "fullName",
    headerName: "Player",
    flex: 1,
    minWidth: PLAYER_NAME_MIN_WIDTH,
    renderCell: ({ row }) => <PlayerNameCell {...row} />,
  },
  {
    field: "hostName",
    headerName: "Host",
    minWidth: 130,
    flex: 1,
  },
  {
    field: "averageVisits6Months",
    headerName: "Avg Visit 6 months",
    minWidth: 120,
    ...numberCol(),
  },
  {
    field: "visitsLast30Days",
    headerName: "Visits Last 30 days",
    minWidth: 120,
    ...numberCol(),
  },
];

export const HostTripTable = (props: Prop): JSX.Element => {
  const { type } = props;
  const response = useHostPlayerTrips(type);
  const isMobile = useMobile();

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
          },
        },
      }}
      name={`host-trips-${type}`}
      response={response}
      columns={columns}
      slotProps={{
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      noRowsMessage="No Trips Found"
      {...props}
    />
  );
};
